import { render, staticRenderFns } from "./import-related-product-attributes-index.vue?vue&type=template&id=8c64d9aa&"
import script from "./import-related-product-attributes-index.vue?vue&type=script&lang=js&"
export * from "./import-related-product-attributes-index.vue?vue&type=script&lang=js&"
import style0 from "./import-related-product-attributes-index.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports